<template>
  <div class="rd-tools">
    <slot></slot>
    <span class="rd-tools__spacer"></span>
    <slot name="right"></slot>
    <report-columns-menu v-if="columns" ref="columns"></report-columns-menu>
    <button
      v-if="shell"
      type="button"
      class="ui-btn ui-btn--sm"
      :aria-pressed="String(shell.density === 'compact')"
      @click="shell.toggleDensity()"
    >
      <v-icon size="16">mdi-format-line-spacing</v-icon>
      {{ shell.density === "compact" ? $t("report_desktop.comfortable") : $t("report_desktop.compact") }}
    </button>
    <button v-if="copy" type="button" class="ui-btn ui-btn--sm" @click="onCopy">
      <v-icon size="16">mdi-content-copy</v-icon>
      {{ $t("report_desktop.copy_table") }}
    </button>
  </div>
</template>

<script>
import ReportColumnsMenu from "./ReportColumnsMenu.vue";

/**
 * Red alata iznad tabele: levo sadržaj ekrana, desno izbor vidljivih kolona (svaka tabela u ekranu), gustina
 * (pamti se po uređaju) i kopiranje. Ekran koji ima svoj izbor kolona prosleđuje `:columns="false"`.
 */
export default {
  name: "ReportTools",
  components: { ReportColumnsMenu },
  inject: {
    shell: { from: "reportShell", default: null },
  },
  props: {
    copy: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    /** Sa sakrivenim kolonama kopira ono što se vidi; inače ekran kopira po svom (događaj copy). */
    async onCopy() {
      const copied = this.$refs.columns ? await this.$refs.columns.copyVisible() : null;
      if (copied === null) {
        this.$emit("copy");
        return;
      }
      this.shell?.showToast(this.$t(copied ? "report_desktop.copied" : "report_desktop.copy_failed"));
    },
  },
};
</script>
